import Immutable from 'immutable';

const initialState = Immutable.Map({
  errors: {},
});

function loadGuidePricingStarted(state, _payload) {
  state.set('record', {});
  state.set('completed', false);
  return state.set('loading', true);
}

function loadGuidePricingCompleted(state, payload) {
  state.set('record', payload);
  state.set('completed', true);
  return state.set('loading', false);
}

function loadGuidePricingFailed(state, payload) {
  state.set('completed', true);
  state.set('record', {});
  state.set('errors', payload.errors);

  return state.set('loading', false);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        LOAD_GUIDE_PRICING: loadGuidePricingStarted,
        LOAD_GUIDE_PRICING_COMPLETED: loadGuidePricingCompleted,
        LOAD_GUIDE_PRICING_FAILED: loadGuidePricingFailed,
      }[type] || (() => state)
    )(state, payload);
  });
}
